import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation('common');
  
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.95) 50%, rgba(255, 255, 255, 0.3) 100%), url('https://public.readdy.ai/ai/img_res/34026118c59c01689d4f584aaacd52ac.jpg')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-6 lg:px-8 py-24">
        <div className="w-full lg:w-1/2">
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
            {t('hero.title')}
          </h1>
          <p className="text-xl text-gray-700 mb-8 leading-relaxed">
            {t('hero.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              className="inline-flex items-center justify-center rounded-full bg-teal-600 px-8 py-4 text-lg font-semibold text-white shadow-lg hover:bg-teal-700 transition-all hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              {t('hero.ctaStart')}
              <i className="ri-arrow-right-line ml-2 text-xl w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a
              href="#services"
              className="inline-flex items-center justify-center rounded-full bg-white px-8 py-4 text-lg font-semibold text-teal-600 shadow-lg hover:shadow-xl transition-all border-2 border-teal-600 whitespace-nowrap cursor-pointer"
            >
              {t('hero.ctaDiscover')}
            </a>
          </div>
          <div className="mt-12 grid grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-600 mb-2">500+</div>
              <div className="text-sm text-gray-600">{t('hero.stats.students')}</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-600 mb-2">95%</div>
              <div className="text-sm text-gray-600">{t('hero.stats.success')}</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-teal-600 mb-2">50+</div>
              <div className="text-sm text-gray-600">{t('hero.stats.universities')}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
